import { render } from "./App.vue?vue&type=template&id=e48491d8&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=e48491d8&lang=sass"
import "./App.vue?vue&type=style&index=1&id=e48491d8&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e48491d8"]])

export default __exports__